export const examAdminReview = {
  pageTitle: "阅卷中心",
  pageSubtitle: "AI 初评 + 人工终评，优先收敛简答题阅卷链路。",
  summary: {
    pending: "待阅条目：{count}",
    shortAnswer: "简答题：{count}",
    aiReviewed: "已 AI 初评：{count}",
  },
  actions: {
    aiReviewShortAnswer: "AI 初评简答题",
    goReview: "去阅卷",
    submitScore: "提交评分",
  },
  messages: {
    scoreSubmitted: "阅卷评分已提交",
    aiReviewCompleted: "AI 初评完成：成功 {success}，失败 {failed}",
  },
  notices: {
    aiReviewHint: "AI 初评只生成建议分，不直接成为最终主观分。人工提交 manual/review 后才会收口。",
  },
  drawers: {
    manualReviewTitle: "人工阅卷",
    manualReviewTitleWithId: "人工阅卷 #{id}",
  },
  fields: {
    score: "得分",
    comment: "评语",
    commentPlaceholder: "输入阅卷说明或得分依据",
    detailJson: "detail_json",
  },
  labels: {
    notReviewed: "未初评",
    stem: "题干",
    aiSummary: "AI 初评摘要",
    suggestedScore: "建议分：{score}",
    context: "上下文",
    aiHits: "AI 命中点",
  },
  table: {
    attemptQuestion: "Attempt Question",
    examId: "考试 ID",
    questionId: "题目 ID",
    questionType: "题型",
    title: "标题",
    aiReview: "AI 初评",
    actions: "操作",
  },
} as const;
